module.exports = Vue;